import { useDownloads } from "@/contexts/DownloadsContext";
import { Download, Loader2 } from "lucide-react";
import type React from "react";

interface DownloadIndicatorProps {
  onClick: () => void;
  className?: string;
}

const DownloadIndicator: React.FC<DownloadIndicatorProps> = ({
  onClick,
  className = "",
}) => {
  const { processingDownloadsCount, newCompletedDownloadsCount } =
    useDownloads();

  const renderIndicator = () => {
    if (processingDownloadsCount > 0) {
      return (
        <Loader2
          size={12}
          className="absolute -top-1 -right-1 text-blue-500 animate-spin"
        />
      );
    } else if (newCompletedDownloadsCount > 0) {
      return (
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full text-white text-xxs flex items-center justify-center">
          {newCompletedDownloadsCount >= 50
            ? "+" + newCompletedDownloadsCount
            : newCompletedDownloadsCount}
        </span>
      );
    }
    return null;
  };

  return (
    <div className="relative">
      <button
        className={`downloads-button text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors relative ${className}`}
        onClick={onClick}
      >
        <Download size={22} />
        {renderIndicator()}
      </button>
    </div>
  );
};

export default DownloadIndicator;
